import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", null, "Privacy Policy", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, "Customers", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, "Data Protection General Statement", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, " This Data Protection Policy outlines Ezo Competitions Limited (t/a “Party Place”) commitment to its customers, supplier network businesses, and other individuals to operate its business activities in a manner which meets the compliance obligations of the Jersey data protection legislation, the Data Protection (Jersey) 2018 Law (“DPJL”) and the General Data Protection Regulation (EU) 2016/679. ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("p", null, " Party Place understands and respects your right to privacy and we are committed to ensuring the confidentiality and security of your personal data and the personal data processing activities within our organisation by applying the appropriate technical and organisational measures required to achieve this objective. ", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, " This document covers the policies and procedures for processing personal data in a compliant manner and outlines the rights of the data subjects in respect of that data. The Privacy Notice below explains how we may use, process and store your personal data. ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", null, "Data Controller", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, " Ezo Competition Limited (t/a “Party Place”) is the data controller of all personal data and data processing activities of its business operating in Jersey, Channel Islands. The business runs an online directory of suppliers who sell products and services required to plan, organize and manage parties/events for customers in Jersey. Party Place also provides services to both its customers and suppliers to assist them in managing the administration of such parties/events. The company operates the website, www.partyplace.je. ", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, " The Registered Office is located at 18 La Ville de L’Eglise, St. Peter, Jersey, JE3 7AR. Ezo Competitions Limited is registered as data controller with the Jersey Office of the Information Commissioner and its number is 70369. ", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("h2", null, "Reference Documents", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "Data Protection (Jersey) Law 2018", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, " Data Protection (Registration and Charges)(Jersey) Regulations 2018 ", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", null, " EU General Data Protection Regulation 2016/679 ", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("h1", null, "Privacy Notice", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("h2", null, "Introduction", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, " This privacy notice explains how Party Place, and its service providers collect, share and use your personal information. You will also find information about how you can exercise your privacy rights in this Notice. ", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", null, " We aim to protect the personal information of all visitors who access our website or services through any mobile application, platform or device (collectively, the “Services”). ", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("p", null, " By using our Services, you agree to Party Place using your personal information as described in this Privacy Notice. The terms “we”, ”us,” or “our” are each intended as a reference to Ezo Competitions Limited and any terms not defined in this Privacy Notice are defined in our Terms. ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("h2", null, "Scope of Application", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", null, " This Privacy Notice applies to our business activities operating within Jersey, Channel Islands, or the personal data processing of the data subjects within Jersey, UK and European Economic Area (EEA). ", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("h2", null, "Personal Data:", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("p", null, " Personal data means any information relating to an identified or identifiable natural person. ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, " Party Place collects the following categories of personal information from customers: ", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("table", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Contact Details:")
    ]),
    /*#__PURE__*/_createVNode("td", null, " Name(s), home address, email address(es), telephone(s) and/or mobile telephone number(s) ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Important Dates or Party Dates:")
    ]),
    /*#__PURE__*/_createVNode("td", null, " Date of birth (optional), Names of family, friends and their date of birth (optional) Important party dates and celebratory dates (optional) ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Access and Security Information:")
    ]),
    /*#__PURE__*/_createVNode("td", null, " MyAccount username and password Mobile number for 2FA access permission IP address (for security checks) Recovery account email address or telephone number ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Booking Details:")
    ]),
    /*#__PURE__*/_createVNode("td", null, " Contact details of party organiser or host Name of party recipient Special instructions (e.g. possible food allergies, attendee disability issues etc.) Delivery address information and instruction ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Marketing Information")
    ]),
    /*#__PURE__*/_createVNode("td", null, " Marketing communication preferences e.g., email, SMS, app notification IP address (for Google analytics website statistics reporting) ")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("strong", null, "Payments")
    ]),
    /*#__PURE__*/_createVNode("td", null, " Booking fee payments (paid to payment providers City Pay, Apple Pay, Google Pay) Payment confirmation details (from payment providers e.g, CityPay, Apple Pay, Google pay etc.) ")
  ])
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Note 1: Payments to supplier(s)"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Party Place does not process any credit/debit card information or details of other digital payment methods used by customers when paying their chosen supplier(s). All such payment transactions are dealt with directly by the supplier(s) when customers select and confirm their booking information with them. ")
], -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Note 2: Payments to Party Place"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Party Place does not hold or process any credit/debit card information or details of other digital payment methods used by customers when paying Party Place. All such payment transactions are dealt with by third-party payment providers (City Pay, Apple Pay, Google Pay) who operate to the highest security standards expected of such payment providers. ")
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Note 3: Special notice regarding children:"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Our Services are not directed to people under 18. We do not knowingly collect personal information from children under 18. If you become aware that a child has provided us with Personal Data without the proper consent, please contact us at dataprotection@partyplace.je we will take steps to remove such information and terminate the account, if required. ")
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("h2", null, "Purposes of Processing", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, " Party Place will use your personal data noted above for the following range of activities: ", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("table", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", null, "Purpose"),
    /*#__PURE__*/_createVNode("th", null, "Lawful Basis")
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "1. Create a dedicated “MyAccount” for you")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To record your contact details, booking details, to store important celebratory dates, reminders, and to manage your account details and marketing preferences. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing is done using the "),
        /*#__PURE__*/_createVNode("strong", null, "performance of a Contract"),
        /*#__PURE__*/_createTextVNode(" legal basis ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "2. Transaction as a “Guest”")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To provide you with the ability to use our services without the need to create a “MyAccount” account. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing is done using the "),
        /*#__PURE__*/_createVNode("strong", null, "performance of a Contract"),
        /*#__PURE__*/_createTextVNode(" legal basis ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "3. Communication with suppliers")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To provide your details, party details, to suppliers in order to obtain quotations, confirmations for the purchase of products and/or services you requested from them. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing is done using the "),
        /*#__PURE__*/_createVNode("strong", null, "performance of a Contract"),
        /*#__PURE__*/_createTextVNode(" legal basis ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "4. Communication with invited guests")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To provide your details, party details, to guests so that they may be able to respond to your invitation and raise any queries with you i.e. when we send a link to Party Place party details via email or SMS or via our website. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing is done using the "),
        /*#__PURE__*/_createVNode("strong", null, "performance of a Contract"),
        /*#__PURE__*/_createTextVNode(" legal basis ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "5. Booking fee and supplier payment")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To facilitate the payment of the party booking fee to Party Place when a charge applies. "),
      /*#__PURE__*/_createVNode("p", null, " To provide your chosen supplier(s) with the information required for them to take payment, make refunds, and for any fraud checks to be performed to protect your payment and card details, when required. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing is done using the "),
        /*#__PURE__*/_createVNode("strong", null, "performance of a Contract"),
        /*#__PURE__*/_createTextVNode(" legal basis ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "6. Dealing with allergy, food ingredients, health & safety queries or concerns")
      ]),
      /*#__PURE__*/_createVNode("p", null, " When required, we may process your personal data to answer any queries in relation to any recorded food ingredients or recorded allergies you may have (or your guests), or any other health and safety concerns, to ensure your safety (and guests) and to address any concerns which you or relevant party(ies) or emergency personnel may have. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing may be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Vital Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "7. Use of SMS, emails and app notifications")
      ]),
      /*#__PURE__*/_createVNode("p", null, " As part of our service to you, we may use SMS text message, email and app notifications to provide you with confirmation of your purchased product(s) or service(s), booked venue and other related services, which may be relating to your order or booking. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing is done using the "),
        /*#__PURE__*/_createVNode("strong", null, "performance of a Contract"),
        /*#__PURE__*/_createTextVNode(" legal basis ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "8. Communication of promotional offers")
      ]),
      /*#__PURE__*/_createVNode("p", null, " When you approve, we may use newsletter, emails, SMS text messaging services to promote special offers for our party and gifting services. Customer must give their “opt-in” consent to receiving such direct marketing communications. Customers can “opt-out” easily from such direct marketing communications either via their own MyAccount settings or by unsubscribing in the marketing emails or changing their app notification settings in the Party Place website or app. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing is done using the "),
        /*#__PURE__*/_createVNode("strong", null, "performance of a Contract"),
        /*#__PURE__*/_createTextVNode(" legal basis ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "9. Use of social media to advertise and promote products and services")
      ]),
      /*#__PURE__*/_createVNode("p", null, " We would like to promote those products and services offered to our customers using various social media channels e.g. using Facebook, Instagram, Twitter etc. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legitimate Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "10. Improving products, services to our customers")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To improve our services, get new ideas, suggestions from our customers, develop new retail experiences. We may refer to customer website and app usage statistical data, customer surveys, trends and noted interests, to help us identify areas for improvements and the development of our services. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legitimate Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "11. Competitions and rewards")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To run competitions and reward programmes, participants will be asked to provide their email address and/or phone number so that we can notify them if they have won a competition or to receive a reward. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Consent"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "12. Recruitment of management and staff.")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To recruit suitably skilled staff, curriculum vitae and reference information from professional bodies, open public forms, public registers, LinkedIn and other channels may be used. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legitimate Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "13. Managing security, access to our computer systems, premises, business assets and applications")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To protect our business computer systems, business premises, assets and staff, where such a requirement arises. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legitimate Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "14. Provision of a safe and secure environment for customers, employees, business assets, and to meet Health & Safety standards")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To operate our business, employee and customer environments to the best health and safety and security standards. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legitimate Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "15. Obtain and maintain insurance cover, managing risks, or obtaining professional advice.")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To protect and assert our legal rights in the areas of insurance, health and safety standards, customer and employee obligations and operating standards. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legitimate Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "16. Comply with legal, tax and regulatory obligation")
      ]),
      /*#__PURE__*/_createVNode("p", null, " To meet our legal obligations to the Jersey government, law enforcement, tax laws, in compliance with business laws and compliance with any other relevant competent authority, agency or regulatory body. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legal Obligation"),
        /*#__PURE__*/_createTextVNode(" legal basis. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createVNode("strong", null, "17. Establishment or defence of a legal claim")
      ]),
      /*#__PURE__*/_createVNode("p", null, " When required, we may process customer data in order to establish a legal claim or defend a legal claim against us. ")
    ]),
    /*#__PURE__*/_createVNode("td", null, [
      /*#__PURE__*/_createVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" Processing will be done using "),
        /*#__PURE__*/_createVNode("strong", null, "Legitimate Interest"),
        /*#__PURE__*/_createTextVNode(" legal basis. You have the right to object to such processing by contacting our data protection manager. ")
      ])
    ])
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("h2", null, "Data Collection Methods:", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("p", null, "We collect personal data in the following ways;", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, " Direct from the customer when they set-up their MyAccount details on the Party Place website and mobile app marketplace, ", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("p", null, " Direct from the customer when they place an order either as a Guest or as a MyAccount customer, ", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("p", null, " Direct from the customer when the communicate with us via email, telephone, voicemail message, website forms, customer reviews, competitions, surveys, SMS text messaging, or app communications, ", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("p", null, " Direct from the customer where they are using our social media platform(s), ", -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("p", null, " From any third-party channels such as public registers, social media, LinkedIn and any other public open forums, ", -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("p", null, " from use of website cookies and beacons which may track your usage of our website, uploading of information to the website, your device ID, your browser type, and how long you interact with our Services, including to facilitate interest-based advertising, ", -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("p", null, " Use of Google Analytics software to understand customer trends, general shopping behaviours and search terms, and use of our website, ", -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("p", null, " We may receive information from third party sources including advertising agencies and networks, but only on the basis that they have obtained your consent or legally permitted basis or required to share your data with us. This data may include demographic group for customer segmentation reviews, ", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("p", null, " We may collect information from third party organisations in relation to relevant analytical reports, market research surveys, and aggregated information in order to use selective/targeted advertising for certain customer groups when using certain social media platforms. ", -1)
const _hoisted_42 = /*#__PURE__*/_createVNode("h2", null, "Information Collected:", -1)
const _hoisted_43 = /*#__PURE__*/_createVNode("p", null, " Customers’ personal data will only be used by us when there is/was a basis for a sales or service transaction/contract, and for non-customer personal information, data processing will be performed in line with the purposes and requirements outlined in this privacy notice. The purposes for the collection and use of personal data is stated above. Only personal data that is necessary for the purposes of assisting our customers with the provision of products or services as outlined above is actively collected. ", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("h2", null, "Special Category Information:", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("p", null, " We may indirectly collect information from you when you contact us via the Party Place website, webforms, email, social media accounts and telephone calls. This information may include special category information, such as health-related information (allergies or dietary requirements) or information about your religion (e.g. if you only eat halal food). While we do not require this information, we ask that you share this information with the restaurant or food supplier only. ", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("p", null, " There may be circumstances were health and safety information (in relation to disability) may also be captured indirectly. Again, this information is primarily for the supplier use. However, there are some situations where you may nonetheless provide this information, e.g. if you make a complaint, and in those circumstances we will only be collecting it with your consent. ", -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("h2", null, "Recipients of Data:", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("p", null, "Personal data collected may be disclosed or transferred to;", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("p", null, " To the Party Place supplier network member(s) that you have selected for placing your party booking details with them, ", -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("p", null, " Data processors who provide services in relation to secure email (e.g. Microsoft), SMS text messaging (e.g. Twilio), app notifications (e.g. Apple and Google), for notifying your order confirmation status and/or direct marketing communications (e.g. MailJet), ", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("p", null, " Party Place’s data processors who provide services in relation to the secure and safe running of its business systems and processes, ", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("p", null, " Professional agents in the provision of required services (e.g. lawyers, bankers, accountants, auditors), ", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("p", null, " Competent authorities as required by law, ", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("p", null, " Law enforcement and fraud prevention agencies, to help tackle fraud or where such disclosure is necessary for compliance with legal obligation, ", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("p", null, " Other third parties when requested by you and when relevant consent has been obtained from you, ", -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("p", null, " Any group company of Party Place, where it is required to deliver the engaged services, to help improve our services and customer experience, ", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("p", null, " Any new owner of the Party Place business should it be acquired or merged with another company. ", -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("p", null, " Third party service providers are bound by the requirements of the Data Processor Agreement obligations, where personal data is to be processed to high standards of confidentially and the required security arrangements are in place. ", -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("h2", null, "Social Media Platforms Belonging to Suppliers:", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("p", null, " As part of our service in providing you with information about your chosen suppliers (or to view all suppliers on our Party Place website and app), our supplier network members have provided links to their websites, Facebook page, instagram, YouTube and other social media channels, where they thought it was appropriate and relevant to advertise and market their products and services. ", -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("p", null, " Customers are hereby informed that Party Place does not take or accept any responsibility or liability for your use of these supplier websites and social media channels, and customers are hereby advised to take care in using them and to check the security features of these third party platforms. It is the responsibility of the suppliers to ensure that their websites and social media channels operate in compliance with relevant data protection laws and the required security standards. ", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("p", null, " Customers (and other data subjects) are advised to refer to the respective privacy notices of these social media platforms to check your data protection and privacy rights. Party Place cannot be held responsible for third party social media platforms or websites activities. ", -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("h2", null, "Transfer and Access to Personal Data:", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("p", null, " Party Place keeps all business and personal data in its possession within Jersey jurisdiction where possible, or alternatively within the UK or the EEA. We will only transfer data outside of these areas where it is absolutely necessary for the performance of the contract agreed by you. ", -1)
const _hoisted_65 = /*#__PURE__*/_createVNode("p", null, " Where the destination of the data transfer is outside Jersey, UK or EEA and does not include a third country that has an “adequacy/equivalence” status, as recognised by the EU Commission, we would always ensure that appropriate safeguards are in place. ", -1)
const _hoisted_66 = /*#__PURE__*/_createVNode("p", null, " Where we cannot guarantee these safeguards, we would always request your consent before the data is transferred. ", -1)
const _hoisted_67 = /*#__PURE__*/_createVNode("h2", null, "Retention of data", -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("p", null, " Party Place will only retain your personal data for as long as is necessary to fulfill the purpose for which it was collected. Summary of the important data retention periods are as follows; ", -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("p", null, " Party Place will retain data in relation to customer and supplier transactions for 10 years from the date of the transaction where they are deemed to be part of the financial records of the business, ", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("p", null, " Customer contact details will be kept for as long as there is an active business relationship, otherwise contact details will be subject to deletion, ", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("p", null, " Accounts that have been inactive for 18 months will be sent reminders or follow-up messages to see if they want them to continue, and if no reply after 90 days, the account information will be annoymised or deleted, ", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("p", null, " Any customer data held after this period will be annoymised, only where it provides a useful basis for trading KPI statistical reporting, ", -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("p", null, " Any other information will be either deleted after 18 months or annoymised if appropriate. ", -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("h2", null, "Data Subject Rights:", -1)
const _hoisted_75 = /*#__PURE__*/_createVNode("p", null, " Where a data subject in the European Union (or any “adequate/equivalent” status country) wishes to exercise their rights under applicable data protection laws, they should contact us by emailing you enquiry to dataprotection@partyplace.je. ", -1)
const _hoisted_76 = /*#__PURE__*/_createVNode("p", null, "Data subjects have a number of rights available to them;", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" access to their personal data, "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" rectification of any inaccuracies, "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" restriction on the processing their data"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" to object to the processing of their data"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" to be forgotten (erasure of your data)"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" right to data portability"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" right to object to automated decision making and profiling "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" right to withdraw consent for those data processing activities based on consent ")
], -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("p", null, " Party Place does not make any decisions based on purely automated means, but if we do, you have a right to object. ", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("p", null, " Each data subject request to exercise the rights noted above will be reviewed against the requirements of the Data Protection (Jersey) Law 2018 and in certain circumstances (e.g. restriction, erasure, objection, data portability) these rights may not be exercisable by the company. Full explanations will be given in such cases. ", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("h2", null, "Making a Complaint:", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("p", null, " The Jersey Office of the Information Commissioner, Channel Islands (“JOIC”), is an independent statutory authority where you can make a complaint or learn more about data protection in Jersey. Their website is https://jerseyoic.org and telephone number is 01534 716530. ", -1)
const _hoisted_82 = /*#__PURE__*/_createVNode("h2", null, "Security Features:", -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("p", null, " Party Place is committed to ensuring the security of your personal data and has implemented appropriate commercially reasonable technical, physical and organisational measures to prevent unauthorised or unlawful processing of your personal data or accidental loss or destruction of your personal data. ", -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("p", null, " The Party Place website, database and email communications are encrypted, thereby providing a layer of security to the personal data being processed on behalf of customer and suppliers. ", -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("h2", null, "Change to this Notice:", -1)
const _hoisted_86 = /*#__PURE__*/_createVNode("p", null, " Party Place may update this Privacy Notice at any time. The updated notice will appear on our website www.partyplace.je and in the published Terms of Business. This Privacy Notice was last approved on 15 September 2021. ", -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("h2", null, "Contact Details:", -1)
const _hoisted_88 = /*#__PURE__*/_createVNode("p", null, " If you have any questions, concerns or complaints with respect to this Privacy Notice or the handling of your privacy or personal information, please contact our data protection manager at dataprotection@partyplace.je or telephone 07797 738743. ", -1)
const _hoisted_89 = /*#__PURE__*/_createVNode("p", null, " If you believe that any information we are holding on you is incorrect or incomplete, you can update your information by going to your MyAccount section of the Party Place website or by writing or emailing us as soon as possible, at the above address. We will promptly correct any information found to be incorrect. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_Header),
      _createVNode(_component_ion_content, { class: "legal-page" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { class: "no-pad" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    sizeXl: "6",
                    offsetXl: "3",
                    sizeLg: "8",
                    offsetLg: "2",
                    sizeMd: "10",
                    offsetMd: "1",
                    sizeSm: "10",
                    offsetSm: "1",
                    size: "10",
                    offset: "1"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _hoisted_2,
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _hoisted_11,
                      _hoisted_12,
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38,
                      _hoisted_39,
                      _hoisted_40,
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _hoisted_44,
                      _hoisted_45,
                      _hoisted_46,
                      _hoisted_47,
                      _hoisted_48,
                      _hoisted_49,
                      _hoisted_50,
                      _hoisted_51,
                      _hoisted_52,
                      _hoisted_53,
                      _hoisted_54,
                      _hoisted_55,
                      _hoisted_56,
                      _hoisted_57,
                      _hoisted_58,
                      _hoisted_59,
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62,
                      _hoisted_63,
                      _hoisted_64,
                      _hoisted_65,
                      _hoisted_66,
                      _hoisted_67,
                      _hoisted_68,
                      _hoisted_69,
                      _hoisted_70,
                      _hoisted_71,
                      _hoisted_72,
                      _hoisted_73,
                      _hoisted_74,
                      _hoisted_75,
                      _hoisted_76,
                      _hoisted_77,
                      _hoisted_78,
                      _hoisted_79,
                      _hoisted_80,
                      _hoisted_81,
                      _hoisted_82,
                      _hoisted_83,
                      _hoisted_84,
                      _hoisted_85,
                      _hoisted_86,
                      _hoisted_87,
                      _hoisted_88,
                      _hoisted_89
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}